<template>
    <div class="openSteps">
        <span :class="{'active':isActiveNum == 1}">人员配置</span>
        <span :class="{'active':isActiveNum == 2}">园区详细信息</span>
        <span :class="{'active':isActiveNum == 3}">作物详细信息</span>
        <span :class="{'active':isActiveNum == 4}">分区设置</span>
        <span :class="{'active':isActiveNum == 5}">病虫害信息</span>
        <span :class="{'active':isActiveNum == 6}">申请开通</span>
    </div>
</template>

<script>

    export default {
        name: "openSteps",
        model: {
            prop: 'isActiveNum'
        },
        props: {
            isActiveNum: {
                type: Number,
                default: 1
            }
        },
    }
</script>

<style scoped lang="less">
    .openSteps{
        padding: 50px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        span{
            width: 150px;
            height: 50px;
            line-height: 50px;
            background: #00407D;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            color: #B9B9B9;
            position: relative;
            &+span{
                margin-left: 90px;
            }
            &:after{
                content: '';
                width: 40px;
                height: 40px;
                background: url("../assets/images/allow_02.png") no-repeat;
                background-size: cover;
                position: absolute;
                right: -70px;
                top: 50%;
                margin-top: -20px;
            }
            &:last-child:after{
                display: none;
            }
        }
        .active{
            color: #fff;
            background: #2D99FF;
            &:after{
                content: '';
                background: url("../assets/images/allow_01.png") no-repeat;
                background-size: cover;
            }
        }
    }
    @media only screen and (max-width: 1600px) { .openSteps span{ font-size: 18px; }}
    @media only screen and (max-width: 1200px) { .openSteps span{ font-size: 16px; }}
    @media only screen and (max-width: 1000px) { .openSteps span{ font-size: 14px; }}
</style>
